<template>
  <div>
    <div class="box11 flex-col">
      <div class="group4 flex-row" style="justify-content: space-between;">
        <div style="display: flex;">
          <div class="wrap1 flex-col">
            <div class="section1 flex-col">
            </div>
          </div>
          <el-dialog :visible="expiration" :show-close="false" :close-on-click-modal="false" width="344px" center>
            <div class="box4">
              <img class="pic1" referrerpolicy="no-referrer" src="./assets/img/warn.png" />
              <div class="box2">
                <span class="txt1">您的服务已到期!</span>
                <span class="infoBox1">请联系客服进行续期<br />客服电话：</span>
                <span class="word1">400-518-512</span>
              </div>
              <!-- <button class="box3" @click="expiration">确定</button> -->
            </div>
          </el-dialog>
          <div class="wrap2 flex-col justify-between">
            <span class="txt3">欢迎，<b>{{ name }}</b></span>
            <span class="txt4" v-if="cooperationExpireTime">合作期限：{{ cooperationExpireTime |
              dataFormat('yyyy-MM-dd')
            }}</span>
          </div>
        </div>

        <div style="display: flex;">
          <div class="wrap3 flex-col">
            <div class="group5 flex-col justify-between">
              <span class="word2">待处理简历</span>
              <span class="word3">{{ pendingResume }} 名</span>
            </div>
          </div>
          <div class="wrap4 flex-col">
            <div class="bd7 flex-row"><span class="info5">壹护精选额度</span></div>
            <div class="bd8 flex-row justify-between">
              <div class="layer5">
                <span class="txt5">{{ resumeGetQuota - monthCount }}</span>
                <span class="word4">/{{ resumeGetQuota }}</span>
              </div>
              <button @click="centerDialogVisible = true" class="layer6 flex-col"><span
                  class="word5">申请提额</span></button>
              <el-dialog :visible.sync="centerDialogVisible" :show-close="false" :close-on-click-modal="false"
                width="344px" center>
                <div class="box4">
                  <img class="pic1" referrerpolicy="no-referrer" src="./assets/img/Increase.png" />
                  <div class="box2">
                    <span class="infoBox1">立即联系客服申请提额吧！<br />客服电话：</span>
                    <span class="word1">400-518-512</span>
                  </div>
                  <button class="box3" @click="centerDialogVisible = false">确定
                  </button>
                </div>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box12 flex-row justify-between">
      <div class="mod5 flex-col">
        <div class="section2 flex-col justify-between">
          <div class="mod6">
            <div class="block2" style="float: left;">
              <!-- <div class="layer7 flex-col"></div>
              <div class="layer8 flex-col">
                <div class="group6 flex-col"></div>
                <div class="group7 flex-col"></div>
              </div> -->
              <img style="width: 18px;" src="./assets/img/add.png">
            </div>
            <span style="float: left;" class="word6">招聘岗位</span>
            <span style="float: right;cursor:pointer;" @click="alllent()" class="info6">全部岗位&gt;</span>
          </div>

          <div class="mod7 test test-1 infinite-list" style="height:577px;width: 100%;cursor:pointer;overflow:auto"
            v-infinite-scroll="load1" infinite-scroll-immediate="false">
            <div class="layer9 flex-col" v-for="(item, index) in loopData0" :key="index" @click="datafun(item.id)">
              <div class="main3 flex-col">
                <div class="layer10 flex-col">
                  <div class="layer11 flex-row justify-between">
                    <div class="group8 flex-col">
                      <img referrerpolicy="no-referrer" src="./assets/img/arrows.png" />
                    </div>
                    <span class="txt6" v-html="item.name"></span>
                  </div>
                </div>
                <div class="layer12 flex-row justify-between">
                  <span class="word7">投递量：{{ item.deliveryCount === null ? 0 : item.deliveryCount }}</span>
                  <span class="info7">{{ getDatetime(item.createTime) }}</span>
                </div>
                <div class="layer13 flex-row justify-between">
                  <span class="txt7">浏览量：{{ item.browseCount === null ? 0 : item.browseCount }}</span>
                  <div class="txt8" :style="{
                    color:
                      item.status === 'disable'
                        ? '#FFB000'
                        : item.status === 'enable'
                          ? '#2c86fd'
                          : '#FF5151',
                  }">
                    {{
                      item.status === "disable"
                        ? "暂未发布"
                        : item.status === "enable"
                          ? "招聘中"
                          : "停止招聘"
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nodata" v-if="loopData0.length == 0">
              <img src="../Candidate/assets/img/NoData.png">
              <p>暂无岗位信息</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mod8 flex-col">
        <div class="outer7 flex-col">
          <div class="section3 flex-row">
            <div>
              <img src="./assets/img/News.png">
              <div class="main4 flex-col justify-between">
                <div class="bd9 flex-col"></div>
                <div class="bd10 flex-col"></div>
              </div>
            </div>
            <span class="info8">消息中心</span>
            <el-badge v-if="unreadMessage" :value="unreadMessage" :max="99" class="wrap6">
              <!--            <div class="wrap6 flex-col"><span class="txt9">{{unreadMessage}}</span></div>-->
            </el-badge>
          </div>
          <div class="section4 flex-col"></div>

          <div class="test test-1 infinite-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled"
            infinite-scroll-immediate="false">
            <div v-for="(item, index) in Msglist" :key="index"
              @click="godatas(item.userId, item.positionName, item.workYear, item.recordId, item.manageStatus, item.id)">
              <div class="section14 flex-row justify-between">
                <div class="block4 flex-col">
                  <div class="layer15 flex-col">
                    <img src="../../views/assets/img/tx.png" alt="">
                  </div>
                  <div v-if="!item.isRead" class="outer13s"></div>
                </div>
                <div class="block5 flex-col justify-between">
                  <span class="word15">{{ item.positionName }}岗位收到新简历投递！</span>
                  <div class="box15 flex-row justify-between">
                    <span class="info15">{{ item.bobyList[0] }}</span>
                    <span class="word16">{{ item.bobyList[1] }}</span>
                    <el-tooltip placement="top" effect="dark" :content="item.bobyList[2]">
                      <span class="txt17">{{ item.bobyList[2] }}</span>
                    </el-tooltip>
                  </div>
                  <div class="box15 flex-row justify-between">
                    <span class="info15">{{ item.createTime | dataFormat('MM月dd日 hh:mm') }}</span>
                    <span class="word16"></span>
                    <span class="txt17"></span>
                  </div>
                </div>
              </div>
              <div class="section15 flex-col"></div>
            </div>
            <div class="nodata" v-if="Msglist.length == 0" style="margin-top: 35%">
              <img src="./assets/img/MessageCenter.png">
              <p>暂无消息</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
export default {
  data() {
    return {
      name: '',
      unreadMessage: '',
      pendingResume: '',
      resumeGetQuota: '',
      cooperationExpireTime: '',
      monthCount: '',
      loopData0: [],
      Msglist: [],
      constants: {},
      centerDialogVisible: false,
      page: 1,
      page1: 1,
      expiration: false,
    }
  },
  methods: {
    addZero(num) {
      if (parseInt(num) < 10) {
        num = "0" + num
      }
      return num
    },
    alllent() {
      this.$store.state.stidx = 2;
      sessionStorage.setItem("store", this.$store.state.stidx);
      this.$router.push({ path: 'Talent' })
    },
    godatas(userId, positionName, workYear, recordId, manageStatus, id) {
      this.$router.push({
        path: '/Candidateils',
        query: { userId: userId, positionName: positionName, workYear: workYear, recordId: recordId, manageStatus: manageStatus, upid: id }
      });
      this.$store.state.stidx = 1;
      sessionStorage.setItem("store", this.$store.state.stidx);
    },
    load() {
      this.page++;
      this.$apiFun.recordMsg(qs.stringify({
        page: this.page,
        pageSize: 10,
        'condition[companyId_EQ]': localStorage.getItem("id"),
      })).then((data) => {
        if (data.code === 200) {
          data.data.list.map((item) => {
            item.bobyList = item.boby.split("-");
            return item;
          });
          this.Msglist = this.Msglist.concat(data.data.list);
        }
      })
    },
    load1() {
      this.page1++;
      this.getlist1()
    },
    getlist() {
      this.$apiFun.recordMsg(qs.stringify({
        page: this.page,
        pageSize: 9,
        'condition[companyId_EQ]': localStorage.getItem("id"),
      })).then((data) => {
        if (data.code === 200) {
          data.data.list.map((item) => {
            item.bobyList = item.boby.split("-");
            return item;
          });
          this.Msglist = this.Msglist.concat(data.data.list);
        }
      })
    },
    getlist1() {
      this.$apiFun.companyPositionShow(qs.stringify({
        page: this.page1,
        pageSize: 10,
        'condition[companyId_EQ]': localStorage.getItem("id"),
        'condition[status_EQ]': '',
        'order': 'createTime desc'
      })).then((data) => {
        if (data.code === 200) {
          this.loopData0 = this.loopData0.concat(data.data.list);
          this.loading.close();
        }
      })
    },
    datafun(id) {
      this.$store.state.stidx = 2;
      sessionStorage.setItem("store", this.$store.state.stidx);
      this.$router.push({
        path: '/Talentils',
        query: { positionId: id }
      })
    },
    getDatetime(str) {
      let oDate = new Date(str)
      let oYear = oDate.getFullYear()
      let oMonth = oDate.getMonth() + 1
      let oDay = oDate.getDate()
      let oHour = oDate.getHours()
      let oMin = oDate.getMinutes()
      let oSen = oDate.getSeconds()
      return oYear + '年' + this.addZero(oMonth) + '月' + this.addZero(oDay) + '日'
    },
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.$store.commit('setLoading', this.loading)
    this.$apiFun.CompanyManagementCenter(qs.stringify()).then((data) => {
      if (data.code === 200) {
        if (data.data.name == undefined) {
          this.$message.error("您不是机构会员！");
          setTimeout(() => {
            this.loading.close();
            this.$store.commit('setLoading', null)
            this.$router.push({ name: 'login' });
          }, 3000);
        } else {
          this.name = data.data.name;
          this.unreadMessage = data.data.unreadMessage;
          this.pendingResume = data.data.pendingResume;
          this.resumeGetQuota = data.data.resumeGetQuota;
          this.monthCount = data.data.monthCount;
          this.cooperationExpireTime = data.data.cooperationExpireTime;
          this.expiration = data.data.isExpire;
          localStorage.setItem("id", data.data.id);
          localStorage.setItem("name", data.data.name);
          this.getlist();
          this.getlist1();
        }
      } else {
        this.$message.error("您不是机构会员！");
        setTimeout(() => {
          this.loading.close();
          this.$store.commit('setLoading', null)
          this.$router.push({ name: 'login' });
        }, 300);
      }
    })
  },
  filters: {    //格式化时间戳的过滤器（注意：时间戳是数字格式，不是字符串格式，不然会显示为Nan）
    dataFormat(value, fmt) {
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
  },
}
</script>
<style lang="less" scoped>
.page .bd1 .outer1 .bd6 .box12 {
  height: 72vh !important;
}

.page .bd1 .outer1 .bd6 .box12 .mod5 {
  width: 77% !important;
}

.page .bd1 .outer1 .bd6 .box12 .mod8 {
  width: 22%;
}

.page .bd1 .outer1 .bd6 .box12 .mod8 .outer7 .section3 .wrap6 {
  width: 22px;
  height: 22px;
}

.page .bd1 .outer1 .bd6 .box12 .mod8 .outer7 .section3 .wrap6 .txt9 {
  margin: 0;
  width: auto;
  line-height: 18px;
}

.layer9 {
  float: left;
}

.info7 {
  text-align: right !important;
}

.test {
  height: 582px;
  overflow: auto;
  float: left;
  margin: 5px;
  border: none;
  border-bottom: none;
}

.scrollbar {
  width: 30px;
  height: 300px;
  margin: 0 auto;
}

.test-1::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.test-1::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}

.test-1::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

/deep/.el-dialog {
  border-radius: 4px;
  width: 344px;
  height: 356px;
}

.box4 {
  width: 300px;
  height: 314px;
  margin-top: -30px;
}

.pic1 {
  width: 295px;
  height: 136px;
}

.box2 {
  width: 216px;
  height: 56px;
  overflow-wrap: break-word;
  text-align: center;
  margin: 31px 0 0 42px;
}

.txt1 {
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 82, 82, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 28px;
}

.infoBox1 {
  font-size: 18px;
  color: rgba(62, 62, 62, 1);
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word1 {
  font-size: 18px;
  font-family: PingFang-SC-Heavy;
  color: rgba(62, 124, 255, 1);
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box3 {
  width: 220px;
  height: 38px;
  background: #3E7CFF;
  border-radius: 40px;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Medium;
  line-height: 22px;
  margin: 43px 0 0 40px;
}

.nodata {
  text-align: center;
  margin-top: 10%;
}

.nodata img {
  width: 266px;
  height: 154px;
}

.nodata p {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 16px;
  text-align: center;
  padding-top: 14px;
}
</style>